export const environment = {
  production: false,
  baseUrl: "https://odoo.iconsejeros.com/api_test/index.jsp?method="
  // baseUrl: "http://127.0.0.1:8080/api_odoo/index.jsp?method="

};
